<template lang="pug">
.mov-modal
  b-modal(v-model="_value" :size="size" no-close-on-backdrop no-close-on-esc hide-footer)
    .default-modal-body(v-if="_value").text-center
      video.mov-video(playsinline autoplay muted loop :src="url" type="video/quicktime" controls)
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### MOVプレビューモーダル
 */
@Component
export default class MovModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** モーダルサイズ */
  @Prop({ default: () => "xl" })
  size!: string;
  /** 表示する画像のURL。S3格納の場合は先に公開URLにしておく必要がある */
  @Prop()
  url!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
.default-modal-body {
  .mov-video {
    width: 100%;
    height: 83vh;
  }
}
</style>
